import { makeAutoObservable } from "mobx";
import { getRemainingDailyLimit } from "services";

export class CheckLimitStore {
  dailyLimit: number | null = null;
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchLimit() {
    this.isLoading = true;
    try {
      const value = await getRemainingDailyLimit();
      this.dailyLimit = value;
    } catch (error) {
      console.error("Failed to fetch daily limit:", error);
    } finally {
      this.isLoading = false;
    }
  }

  async refetchLimit() {
    await this.fetchLimit();
  }
}
